import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    borderRadius: '10px',
    padding: theme.spacing(2, 1, 1),
  },
  list: {
    paddingInlineStart: theme.spacing(4),

    '& li:not(:last-child)': {
      marginBottom: theme.spacing(1),
    },
  },
}));
